import styled from "styled-components";

import { bp, flexColumn, media } from "@styles/Utilities.styled";


export const StyledProfile = styled.section`
  display: grid;
  gap: 4rem;
  margin-top: 2rem;
  margin-bottom: 8rem;

  ${media(bp.medium)} {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }

  ${media(bp.large2)} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .body {
    ${flexColumn}
    gap: 1rem;
    margin-top: 1.5rem;

    .form-field {
      .input {
        padding-left: 1em;
        transition: padding 0.1s;
        background: none;

        &:read-only {
          outline: none !important;
          border: none !important;
          padding-left: 0;
          /* color: var(--clr-gray-400); */
          color: var(--clr-primary-700);
          /* color: var(--clr-primary-400); */
        }

        &::placeholder {
          font-size: inherit;
        }
      }
    }
  }

  .card {
    ${flexColumn}
    padding: 1.5rem 1.5rem 1rem;
    background-color: var(--clr-white);
    border: 1px solid var(--clr-gray-150);
    border-radius: var(--border-radius-3);
  }
`;
